import React from "react";
import styles from "./HomeEntityList.module.scss";
import { IconPack } from "Explore/Config/Icons";
import { useNavigate } from "react-router-dom";
import { List } from "antd";
import { LoadingListCard } from "Explore/Components";

const HomeEntityList = ({
  entity,
  entityTitle,
  browseTitle,
  entityData,
  grid,
  backgroundImage,
  componentNum,
  CardComponent,
}) => {
  const navigate = useNavigate();
  return (
    <div className={styles["category"]}>
      <div className={styles["title"]}>
        <p className={styles["title-name"]}>{entityTitle}</p>
        <div
          className={styles["browse"]}
          onClick={() => {
            navigate(`/explore/${entity}`);
          }}
        >
          <p>{window.screen.width < 480 ? "Browse" : browseTitle}</p>
          {IconPack.arrow}
        </div>
      </div>
      <LoadingListCard
        isLoading={entityData.isLoading}
        grid={grid}
        backgroundImage={backgroundImage}
        componentNum={componentNum}
        component={
          <List
            grid={grid}
            dataSource={entityData.data.slice(0, componentNum)}
            renderItem={(item, index) => {
              return (
                <List.Item key={index}>
                  <CardComponent data={item} />
                </List.Item>
              );
            }}
          />
        }
      />
      <div className={styles["show-more"]}>
        <p>Continue explore {entityTitle}</p>
        <button
          onClick={() => {
            navigate(`/explore/${entity}`);
          }}
        >
          Show more
        </button>
      </div>
    </div>
  );
};

export default HomeEntityList;
